import { useLocation } from 'react-router-dom';

function useBaseMatch(baseRoute) {
  const location = useLocation();
  return location.pathname.startsWith(baseRoute);
}

export default useBaseMatch;
